import { create } from 'zustand';
import { WarningState } from '../types';

interface WarningStore extends WarningState {
    setWarning: (warning: Partial<WarningState>) => void;
    clearWarning: () => void;
}

export const useWarningStore = create<WarningStore>((set) => ({
    trialDays: null, // DEPRECATED
    trialWarning: null, // DEPRECATED
    usageWarning: null,
    usagePercentage: null,
    currentPlan: null,

    setWarning: (warning) => set((state) => ({ ...state, ...warning })),
    clearWarning: () => set({
        trialDays: null,
        trialWarning: null,
        usageWarning: null,
        usagePercentage: null,
        currentPlan: null,
    }),
}));
